import React, { useState, useEffect, useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { message } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import { InfoWraper, UserDropDwon } from './auth-info-style';
import PasswordPopup from './passwordPopup'
import { Popover } from '../../popup/popup';
import Heading from '../../heading/heading';
import { getAxiosInstance } from '../../../Api/ApiConfig';
import { clearUserData, setUserData } from '../../../redux/MlReduxCalls/LocalDataReduxStore';

function AuthInfo() {
  const history = useHistory();
  const didFetch = useRef(false);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [userName, setUserName] = useState()
  const [mustHave, setMustHave] = useState();
  const [userId, setUserId] = useState()
  const localData = useSelector((state) => state.localRedux);
  const Role = localData?.MultiverseRole
  const urlPathname = window.location.pathname;
  const urlSearch = window.location.search;
  const combinedUrl = urlPathname + urlSearch;
  const defaultTimeZone = "(GMT+10:00) Australia/Sydney";
  const showModal = () => {
    setOpen(true);
  };
  const SignOut = async () => {
    // e.preventDefault();
    const formData = {}
    const response = await getAxiosInstance().post(`/usermgmt/logOut`, formData)
    if (response.data.statusCode === 200) {
      message.success("Logged out successfully. Have a great day!")
      localStorage.removeItem('Multiverse-Expire');
      clearUserData()
      history.push('/');
      window.location.reload();
    }
  };

  async function fetchProfile() {
    if (Role) {
      if (Role === 'Multivrse Admin' || Role === 'Standard User' || Role === 'Translator' || Role === 'Proof Reader') {
        try {
          const response = await getAxiosInstance().get(`/usermgmt/getByUserProfile`);
          setUserId(response?.data?.userProfileId)
          const timeZone = response?.data?.timeZone;
          if (timeZone !== "" && timeZone !== null && timeZone !== undefined) {
            dispatch(setUserData({
              MultiverseTimezone: timeZone
            }));
          } else {
            dispatch(setUserData({
              MultiverseTimezone: defaultTimeZone
            }));
          }
          // getLoginDetails('InternalUser')
          dispatch(setUserData({
            MultiverseUserId: response?.data?.userProfileId,
            MultiverseUName: `${response?.data?.firstName} ${response?.data?.lastName}`,
            MultiverseUEmail: response?.data?.email
          }));
          setUserName(`${response?.data?.firstName} ${response?.data?.lastName}`)
        } catch (error) {
          console.error(error);
        }
      } else {
        try {
          const response = await getAxiosInstance().get(`/usermgmt/getByCustomerProfile`);
          setUserId(response?.data?.customer_profile_id)
          const timeZone = response?.data?.time_zone;
          if (timeZone !== "" && timeZone !== null && timeZone !== undefined) {
            dispatch(setUserData({
              MultiverseTimezone: timeZone
            }));
          } else {
            dispatch(setUserData({
              MultiverseTimezone: defaultTimeZone
            }));
          }
          // getLoginDetails('CustomerUser')
          dispatch(setUserData({
            MultiverseUserId: response?.data?.customer_profile_id,
            MultiverseCUAccount: response?.data?.customer_account,
            MultiverseUName: `${response?.data?.first_name} ${response?.data?.last_name}`,
            MultiverseUEmail: response?.data?.email
          }));
          setUserName(`${response?.data?.first_name} ${response?.data?.last_name}`)
        } catch (error) {
          console.error(error);
        }
      }
    }
  }
  useEffect(() => {
    if (!didFetch.current) {
      didFetch.current = true;
      fetchProfile();
    }
  }, []);
  const userContent = (
    <UserDropDwon>
      <div className="user-dropdwon">
        <figure className="user-dropdwon__info">
          <span className='details_span_Tag' style={{ width: "45px", height: "45px", marginRight: "15px", fontSize: "25px" }}>
            {userName?.slice(0, 1)?.toUpperCase()}
          </span>
          <figcaption>
            <Heading as="h5">{userName}</Heading>
            <p>{Role === "Customer Admin" ? "Account Admin" : Role}</p>
          </figcaption>
        </figure>
        <ul className="user-dropdwon__links">
          <li>
            {Role === 'Multivrse Admin' || Role === 'Standard User' || Role === 'Translator' || Role === 'Proof Reader' ?
              < Link to="/dashboard/Profile-Page">
                <FeatherIcon icon="at-sign" /> Profile
              </Link>
              : <Link to="/dashboard/profilepage">
                <FeatherIcon icon="at-sign" /> Profile
              </Link>}
          </li>
          <li>
            <Link to={combinedUrl} onClick={showModal}>
              <FeatherIcon icon="key" /> Change Password
            </Link>
          </li>
        </ul>
        <Link className="user-dropdwon__bottomAction" onClick={() => SignOut()} to="#">
          <FeatherIcon icon="log-out" /> Log Out
        </Link>
      </div>
    </UserDropDwon >
  );
  return (
    <>
      <InfoWraper>
        <div className="nav-author">
          <Popover placement="bottomRight" content={userContent} action="click">
            <Link to="#" className="head-example">
              <span className='details_span_Tag' style={{ display: "flex", width: "32px", height: "32px", fontSize: "19px", color: "#ffffff", background: "#ababab" }}>
                {userName?.slice(0, 1)?.toUpperCase()}
              </span>
            </Link>
          </Popover>
        </div>
      </InfoWraper>
      {open && <PasswordPopup open={open} setOpen={setOpen} userId={userId} mustHave={mustHave} setMustHave={setMustHave} />}
    </>
  );
}

export default AuthInfo;
